var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-web"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "web",
    clipPath: "url(#clip-web)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11426",
    "data-name": "Group 11426",
    transform: "translate(-14.708 -9.516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11425",
    "data-name": "Group 11425",
    transform: "translate(15.085 14.378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "television",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1672_",
    d: "M33.084,67.065H1.164A1.164,1.164,0,0,0,0,68.229V85.578a1.164,1.164,0,0,0,1.164,1.164h31.92a1.164,1.164,0,0,0,1.164-1.164V68.229A1.164,1.164,0,0,0,33.084,67.065Z",
    transform: "translate(0 -67.065)",
    fill: "#FDC781"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1626_",
    d: "M155.793,392.98h-3.951v-1.561h-5.4v1.561h-3.951a1.01,1.01,0,0,0,0,2.019h13.3a1.01,1.01,0,0,0,0-2.019Z",
    transform: "translate(-132.019 -369.723)",
    fill: "#FDC781"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.e9e73da009313fbf380bb757c20ef97e.svg";
export { ForwardRef as ReactComponent };